import { buildPlatformOrganization } from "../platformOrganizationLd";

export function buildHomePageJsonLd(
  origin: string,
  title: string,
  description: string
): {
  "@context": string;
  "@graph": unknown[];
} {
  const base = `${origin.replace(/\/+$/, "")}/`;
  const organization = buildPlatformOrganization(origin);
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": `${base}#website`,
        url: base,
        name: title,
        description,
        publisher: { "@id": organization["@id"] },
        inLanguage: "en",
      },
      organization,
    ],
  };
}
